"use strict";
var appendRowBtn = document.querySelector(".append-row");
var appendColumnBtn = document.querySelector(".append-column");
var removeRowBtn = document.querySelector(".remove-row");
var removeColumnBtn = document.querySelector(".remove-column");
appendRowBtn.addEventListener("click", function() {
    var rows = document.querySelectorAll("tr");
    var columns = rows[0] ? rows[0].children.length : 0;
    if (rows.length >= 10) return;
    var newRow = document.createElement("tr");
    for(var i = 0; i < columns; i++){
        var newColumn = document.createElement("td");
        newRow.appendChild(newColumn);
    }
    document.querySelector("tbody").appendChild(newRow);
    var newRows = document.querySelectorAll("tr");
    appendRowBtn.disabled = newRows.length >= 10;
    removeRowBtn.disabled = newRows.length <= 2;
});
appendColumnBtn.addEventListener("click", function() {
    var _document_querySelectorAll_;
    var rows = document.querySelectorAll("tr");
    var columns = rows[0] ? rows[0].children.length : 0;
    if (columns >= 10) return;
    rows.forEach(function(row) {
        var newColumn = document.createElement("td");
        row.appendChild(newColumn);
    });
    var newColumns = ((_document_querySelectorAll_ = document.querySelectorAll("tr")[0]) === null || _document_querySelectorAll_ === void 0 ? void 0 : _document_querySelectorAll_.children.length) || 0;
    appendColumnBtn.disabled = newColumns >= 10;
    removeColumnBtn.disabled = newColumns <= 2;
});
removeRowBtn.addEventListener("click", function() {
    var rows = document.querySelectorAll("tr");
    if (rows.length <= 2) return;
    if (rows.length > 0) rows[rows.length - 1].remove();
    var newRows = document.querySelectorAll("tr");
    appendRowBtn.disabled = newRows.length >= 10;
    removeRowBtn.disabled = newRows.length <= 2;
});
removeColumnBtn.addEventListener("click", function() {
    var _document_querySelectorAll_;
    var rows = document.querySelectorAll("tr");
    var columns = rows[0] ? rows[0].children.length : 0;
    if (columns <= 2) return;
    rows.forEach(function(row) {
        if (row.children.length > 0) row.removeChild(row.lastElementChild);
    });
    var newColumns = ((_document_querySelectorAll_ = document.querySelectorAll("tr")[0]) === null || _document_querySelectorAll_ === void 0 ? void 0 : _document_querySelectorAll_.children.length) || 0;
    appendColumnBtn.disabled = newColumns >= 10;
    removeColumnBtn.disabled = newColumns <= 2;
});

//# sourceMappingURL=index.20e64ad6.js.map
